import { render, staticRenderFns } from "./propertyinfo.vue?vue&type=template&id=e52ccd6c&scoped=true&"
import script from "./propertyinfo.vue?vue&type=script&lang=js&"
export * from "./propertyinfo.vue?vue&type=script&lang=js&"
import style0 from "./propertyinfo.vue?vue&type=style&index=0&id=e52ccd6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e52ccd6c",
  null
  
)

export default component.exports